var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "entry-layout-header" },
    [
      _c("span", { staticClass: "entry-layout-header-logo" }, [
        _c("img", { style: _vm.logoStyle, attrs: { src: _vm.logo } })
      ]),
      _c(
        "div",
        { staticClass: "entry-layout-menus" },
        [
          _c(
            "a-tabs",
            { attrs: { activeKey: _vm.menusActiveID } },
            _vm._l(
              _vm.menus.filter(function(item) {
                return _vm.paidPageFlag === 1
                  ? item.childMenus.some(function(subItem) {
                      return subItem.updateFlag === 1
                    })
                    ? true
                    : false
                  : true
              }),
              function(menuInfo) {
                return _c(
                  "a-tab-pane",
                  { key: menuInfo.key, attrs: { closable: menuInfo.closable } },
                  [
                    _c(
                      "a-dropdown",
                      {
                        attrs: { slot: "tab" },
                        slot: "tab",
                        model: {
                          value: menuInfo.visible,
                          callback: function($$v) {
                            _vm.$set(menuInfo, "visible", $$v)
                          },
                          expression: "menuInfo.visible"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "entry-layout-header-menus__item__label",
                            class: {
                              "entry-layout-header-menus__item__label--hover":
                                menuInfo.visible
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("menuLocalName")(menuInfo)))]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "entry-layout-header-menus__item__children",
                            attrs: { slot: "overlay" },
                            slot: "overlay"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "entry-layout-header-menus__item__children__tools"
                              },
                              [
                                _vm.paidPageFlag
                                  ? _c(
                                      "a-tooltip",
                                      { attrs: { placement: "bottom" } },
                                      [
                                        _c("template", { slot: "title" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.paidPageFlag === 2
                                                  ? _vm.$t("layouts.hide", [
                                                      _vm.$t("layouts.paidPage")
                                                    ])
                                                  : _vm.$t("layouts.show", [
                                                      _vm.$t("layouts.paidPage")
                                                    ])
                                              )
                                            )
                                          ])
                                        ]),
                                        _c("a-button", {
                                          staticStyle: { color: "#999" },
                                          attrs: {
                                            type: "link",
                                            icon:
                                              _vm.paidPageFlag === 1
                                                ? "eye-invisible"
                                                : "eye"
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.switchPaidPageFlag.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._l(
                              menuInfo.childMenus.filter(function(find) {
                                return _vm.paidPageFlag === 2
                                  ? true
                                  : find.updateFlag === 1
                              }),
                              function(childMenus, index) {
                                return [
                                  _c("menus-item", {
                                    key: index,
                                    attrs: {
                                      currentLang: _vm.currentLang,
                                      menu: childMenus,
                                      favorites: _vm.favorites
                                    },
                                    on: { click: _vm.handleMenuChange }
                                  })
                                ]
                              }
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ],
                  1
                )
              }
            ),
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "entry-layout-search-wrapper" },
        [
          _c(
            "a-popover",
            {
              attrs: { placement: "bottomLeft", trigger: "focus" },
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c(
                "a-input",
                {
                  staticClass: "entry-layout-search-input",
                  staticStyle: { "font-size": "12px" },
                  attrs: {
                    size: "small",
                    "allow-clear": "",
                    placeholder: _vm.$t("layout.searchKeyword")
                  },
                  on: { focus: _vm.show, blur: _vm.hide },
                  model: {
                    value: _vm.keyword,
                    callback: function($$v) {
                      _vm.keyword = $$v
                    },
                    expression: "keyword"
                  }
                },
                [
                  _c("a-icon", {
                    staticClass: "entry-layout-search-icon",
                    attrs: { slot: "prefix", type: "search" },
                    slot: "prefix"
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "entry-layout-history",
                  attrs: { slot: "content" },
                  slot: "content"
                },
                [
                  _c(
                    "div",
                    { staticClass: "entry-layout-history__body" },
                    [
                      _vm._l(_vm.searchList, function(link) {
                        return [
                          _c(
                            "div",
                            {
                              key: link.key,
                              staticClass: "entry-layout-history__link",
                              on: {
                                click: function($event) {
                                  return _vm.handleSearchClick(link.key, {
                                    statisticsType: 1,
                                    searchKey: _vm.keyword
                                  })
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "entry-layout-history__link__main",
                                  domProps: { innerHTML: _vm._s(link.html) }
                                },
                                [_vm._v(_vm._s(_vm._f("menuLocalName")(link)))]
                              ),
                              _c("a-icon", {
                                staticClass: "entry-layout-history__icon",
                                attrs: { type: "caret-right" }
                              })
                            ],
                            1
                          )
                        ]
                      }),
                      _vm.searchList.length === 0
                        ? _c(
                            "div",
                            { staticClass: "entry-layout-history__empty" },
                            [_vm._v(_vm._s(_vm.$t("layouts.text.undefined")))]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _c("div", { staticClass: "entry-layout-history__foot" }, [
                    _c(
                      "div",
                      {
                        staticClass: "entry-layout-history__foot__btn",
                        on: { click: _vm.viewAll }
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { type: "menu" }
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("layouts.ViewAll")))])
                      ],
                      1
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "entry-layout-history",
                  attrs: { slot: "title" },
                  slot: "title"
                },
                [
                  _c("div", { staticClass: "entry-layout-history__header" }, [
                    _c("div", { staticClass: "entry-layout-history__title" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("layouts.history")) + "：")
                      ]),
                      _vm.panesHistory.length === 0
                        ? _c("span", { staticStyle: { color: "#999" } }, [
                            _vm._v(_vm._s(_vm.$t("layouts.text.undefined")))
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      { staticClass: "entry-layout-history__list" },
                      _vm._l(_vm.panesHistory, function(pane) {
                        return _c(
                          "div",
                          {
                            key: pane.key,
                            staticClass: "entry-layout-history__item",
                            on: {
                              click: function($event) {
                                return _vm.handleSearchClick(pane.key, {
                                  statisticsType: 3,
                                  searchKey: ""
                                })
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm._f("menuLocalName")(pane)))]
                        )
                      }),
                      0
                    )
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._t("rightContentRender")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }